export type DriverOnboardingOutcome =
  | 'active_by_invitation'
  | 'existing_active_employment'
  | 'pending_no_invitation'
  | 'pending_no_license'
  | 'company_contact_submitted'
  | 'failed';

export type DriverOutcomeRoute =
  | '/dashboard/home'
  | '/onboarding/company-contact-pending';

/** Keep unknown-company leads out of the operational dashboard and form loop. */
export function routeForDriverOutcome(outcome: DriverOnboardingOutcome): DriverOutcomeRoute {
  return outcome === 'company_contact_submitted'
    ? '/onboarding/company-contact-pending'
    : '/dashboard/home';
}